// removed by extract-text-webpack-plugin
module.exports = {"preview":"_1d6TLQFCiYAkBGdhk-JNIW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SortableList/SortableList.scss
// module id = 1320
// module chunks = 1